// extracted by mini-css-extract-plugin
export var deleteModal = "_gb-0";